/**
 * JSON-LD helpers for `<script type="application/ld+json">` in `svelte:head`.
 * Add type-specific builders under `$lib/seo/schemas/`.
 */

/**
 * Serialize structured data for safe `{@html ...}` injection inside a script tag.
 * Escapes `<` so user/content strings cannot close the script tag.
 */
export function stringifyJsonLdForHtml(data: unknown): string {
	return JSON.stringify(data).replace(/</g, '\\u003c');
}

/** Full `<script type="application/ld+json">…</script>` string for `{@html ...}`. */
export function jsonLdScriptTag(data: unknown): string {
	return `<script type="application/ld+json">${stringifyJsonLdForHtml(data)}</script>`;
}
